import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  clearError,
  loginThunk,
  logout as logoutAction,
} from '../store/slices/auth.slice';
import { LoginCredentials } from '../types/usuario';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const user = auth.user;

  const hasPermission = useCallback(
    (key: string): boolean => user?.permissions?.includes(key) ?? false,
    [user],
  );

  return {
    user,
    accessToken: auth.accessToken,
    isLoggedIn: auth.isLoggedIn,
    isLoading: auth.status === 'loading',
    error: auth.error,
    hasPermission,
    login: (credentials: LoginCredentials) =>
      dispatch(loginThunk(credentials)).unwrap(),
    logout: () => dispatch(logoutAction()),
    clearError: () => dispatch(clearError()),
  };
};
